import { FC } from 'react'
import { Table, Toolbar, BreadcrumHeader } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import { BreadcrumbItemType } from 'shared/molecules/Breadcrum/Breadcrum'
import { useGetRuleConfigListQuery } from '../clientApiSlice'
import '../client.scss'

const { Column, HeaderCell, Cell, StatusCell, DateTimeCell } = Table

const RuleConfigrationList: FC = () => {
  const { onPageChange, requestBody } = useTableHandlers({
    page: { size: 10, number: 0 }
  })
  const { data, isLoading } = useGetRuleConfigListQuery(requestBody)

  const handleTabChange = () => {}
  const COLUMNS = [
    { key: 'ruleName', label: 'Rule Name' },
    { key: 'objectName', label: 'Object Name' },
    { key: 'clientId', label: 'Client Id' }
  ]

  const options = [
    {
      label: 'All',
      value: 'All',
      onClick: () => handleTabChange()
    }
  ]
  const total = data?.totalElements ?? 0

  const breadcrumbItems: BreadcrumbItemType[] = [
    { label: 'Rule-Configuration', isActive: true }
  ]
  return (
    <div className="list">
      <BreadcrumHeader items={breadcrumbItems} />
      <Toolbar options={options} total={total} />
      <div className="list__main-container">
        <Table
          data={data?.content ?? []}
          loading={isLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={10}
          onPageChange={onPageChange}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={key} tooltip />
              </Column>
            )
          })}

          <Column align="center" key="active" flexGrow={1} sortable>
            <HeaderCell>Active</HeaderCell>

            <StatusCell
              dataKey="active"
              posDataLabel="Active"
              negDataLabel="Inactive"
            />
          </Column>

          <Column flexGrow={1} align="center">
            <HeaderCell>CreatedAt</HeaderCell>
            <DateTimeCell dataKey="createdAt" format="dd/MMM/yy, h:mm a" />
          </Column>
        </Table>
      </div>
    </div>
  )
}
export default RuleConfigrationList
